module.exports = __webpack_public_path__ + "images/rollsroyce05cb18e4f29adf34d4087129e4d15f13.png";